import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMdFormActionState } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChallengeTeamEntity } from '../../../meta-data/app-meta-data.service';
import { TeamFormService } from '../services/team-form.service';
import { CentralDataService } from '../../streaker-central/services/central-data.service';

export const EDIT_TEAM_BANNER = 'fitness-team-banner-edit';
export const STYLE_TEAM_BANNER = 'fitness-team-banner-style';

@DwAction({ keyName: EDIT_TEAM_BANNER, display: 'Edit team', actionType: DwActionType.formAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class EditTeamBannerAction implements DwActionHandler {
    constructor(private forms: TeamFormService, private data: CentralDataService) {}
    handleAction(state: DwMdFormActionState): Observable<DwActionResult> {
        return editBanner(state, this.forms, this.data, false);
    }
}

@DwAction({ keyName: STYLE_TEAM_BANNER, display: 'Style', actionType: DwActionType.formAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class StyleTeamBannerAction implements DwActionHandler {
    constructor(private forms: TeamFormService, private data: CentralDataService) {}
    handleAction(state: DwMdFormActionState): Observable<DwActionResult> {
        return editBanner(state, this.forms, this.data, true);
    }
}

function editBanner(state: DwMdFormActionState, forms: TeamFormService, data: CentralDataService, style: boolean): Observable<DwActionResult> {
    const team = state.formApi.getFormData<ChallengeTeamEntity>();
    if (!(team?.ChallengeTeamId > 0)) { return of(Object.assign(new DwActionResult(), { success: false, cancelled: true })); }
    return (style ? forms.style(team.ChallengeTeamId) : forms.edit(team.ChallengeTeamId)).pipe(map(saved => {
        const result = new DwActionResult();
        result.cancelled = saved.cancelled;
        result.success = !saved.cancelled && saved.data?.ChallengeTeamId === team.ChallengeTeamId;
        if (result.success) { data.updateTeam({ ...team, ...saved.data }); }
        return result;
    }));
}
